module.exports = __webpack_public_path__ + "static/media/HP_card_wedgwood.8dd8f339.jpg";